<template>
    <div class="">
        <div class="d-flex">
            <div class="form-group d-flex">
                <label class="p-2">search</label>
                <input type="text" class="form-control" v-model="search"> 
            </div> 												
            <div class="form-group d-flex">
                <label class="p-2">from</label>
                <input type="date" name="bday" max="3000-12-31" 
                min="1000-01-01" class="form-control" v-model="from_date"> 
            </div> 
            <div class="form-group d-flex">
                <label class="p-2">to</label>
                <input type="date" name="bday" max="3000-12-31" 
                min="1000-01-01" class="form-control" v-model="to_date"> 
            </div> 
            <div class="ml-2" @click="getPurchases()">
                <button class="btn btn-outline-success">get sales</button>
            </div>						
        </div>
        <table class="table table-borderless table-responsive-sm">
                <thead>
                    <tr>
                        <th scope="col">Date Received</th>                     
                        <th scope="col">Location</th>
                        <th scope="col">Qty</th>
                        <th scope="col">Buying Price</th>
                        <th scope="col">Base Price</th>
                        <th scope="col">Retail Price</th>
                        <th scope="col">Wholesale Price</th>                                   
                        <th scope="col">Invoice Number</th>
                        <th scope="col">Variant Id</th>
                        <th scope="col"></th>
                    </tr>
                </thead>                	                            													                            
                <tbody>
                    <tr v-for="(purchase,index) in purchases" :key="index">
                        <td>{{purchase.date_received | dateformat}}</td>                      
                        <td>{{purchase.location_id}}</td>
                        <td>{{purchase.quantity}}</td>
                        <td>{{purchase.buying_price | intcomma}}</td>
                        <td>{{purchase.base_price | intcomma }}</td>                                    
                        <td>{{purchase.retail_price | intcomma}}</td>
                        <td>{{purchase.wholesale_price | intcomma}}</td>
                        <td>{{purchase.invoice_number}}</td>
                        <td>{{purchase.variant_id}}</td>
                        <td >
                            <span class="hidden" style="position:absolute;right: 0px;">
                                <span style="height: 25px; visibility: hidden">hidden</span>
                                <span class="d-flex mb-4">
                                    <button class="btn btn-sm btn-success" 
                                        >
                                        view expense
                                    </button>
                                    <button class="ml-2 btn btn-sm btn-danger">remove</button>                                                                        
                                </span>										                                            
                            </span>
                        </td>
                    </tr>														
                </tbody>					
        </table> 
    </div>
</template>
<script>
    export default {
        name: 'productPurchases',
        props: {
            product_id: null
        },
        data(){
            return{
                purchases:null,
                from_date: null,
                to_date: null,
            }
        },
        mounted(){
            this.from_date = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
            this.to_date = this.$moment().format('YYYY-MM-DD')
            this.getPurchases()            
        },
        methods:{		
            //get_ purchases
            getPurchases: function(){            
                this.$http({
                    method:'get',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/purchases/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },
                    params:{
                        date0: this.from_date,
                        date1: this.to_date
                    },
                }).then((response)=>{
                    this.purchases = response.data
                    //filter where product is this product
                    this.purchases = this.purchases.filter((purchase)=>{
                        return purchase.product_id === this.product_id
                    })
                }).catch((err)=>{
                    this.$emit('alert',err)
                })
            },
        }
    }
</script>
          